// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { GridContainerProps } from "@insite/mobius/GridContainer";
import { GridItemProps } from "@insite/mobius/GridItem";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { avoidBreakInsidePrintElement, color, mergeWithCss } from "@west/XDL/Utilities";
import { css } from "styled-components";

interface OrderTotalDisplaySharedStyles {
    mainContainer: GridContainerProps;
    label: TypographyPresentationProps;
    value: TypographyPresentationProps;
    labelGridItem: GridItemProps;
    valueGridItem: GridItemProps;
    totalLabel?: TypographyPresentationProps;
    totalValue?: TypographyPresentationProps;
    titleText?: TypographyPresentationProps;
    styledHr?: InjectableCss;
    wrapper?: InjectableCss;
}

const label: TypographyPresentationProps = {
    size: 14,
    weight: "normal",
    css: css`
        letter-spacing: 0;
        line-height: 22px;
    `,
};
const value: TypographyPresentationProps = {
    size: 14,
    weight: "bold",
    css: css`
        letter-spacing: 0;
        line-height: 22px;
        margin-left: auto;
    `,
};
export const orderTotalDisplaySharedStyles: OrderTotalDisplaySharedStyles = {
    mainContainer: {
        gap: 0,
        offsetCss: css`
            row-gap: 8px;
        `,
    },
    titleText: {
        variant: "h3",
        forwardAs: "h2",
        css: css`
            margin-bottom: 0;
        `,
    },
    labelGridItem: {
        width: 7,
    },
    valueGridItem: {
        css: css`
            @media print {
                text-align: right;
            }
        `,
        width: 5,
    },
    label: {
        ...label,
    },
    value: {
        ...value,
    },
    totalLabel: {
        ...mergeWithCss(label, { size: 16, lineHeight: "26px" }),
    },
    totalValue: {
        ...mergeWithCss(value, { size: 16, lineHeight: "26px" }),
    },
    styledHr: {
        css: css`
            width: 100%;
            border: none;
            border-bottom: 1px solid ${color("common.border")};
            margin: 0;
        `,
    },
    wrapper: {
        css: css`
            width: 100%;
            display: flex;
            padding: 13px;
            border: 1px solid ${color("common.border")};
            background-color: ${color("common.white")};
            @media print {
                max-width: 400px;
            }
            ${avoidBreakInsidePrintElement}
        `,
    },
};
